import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ServerErrorAlert } from '../config/helpers';
import { standardizeInquiries } from '../utils/inbox';
import InboxLayout from '../components/inbox/InboxLayout';
import { fetchInquiriesIfNeeded } from '../actions/fetchInquiries';

export default function Inbox() {
  const dispatch = useDispatch();
  const { status, results } = useSelector(
    state => state.askVA.inquiriesHistory,
  );

  useEffect(() => {
    dispatch(fetchInquiriesIfNeeded());
  }, [dispatch]);

  if (status === 'error') {
    return (
      <va-alert status="info" className="vads-u-margin-y--4">
        <ServerErrorAlert />
      </va-alert>
    );
  }

  if (status === 'idle' || status === 'loading') {
    return (
      <va-loading-indicator
        data-testid="loading-indicator"
        message="Loading..."
      />
    );
  }

  const { standardInquiries, types, uniqueCategories, uniqueStatuses } =
    standardizeInquiries(results);

  return (
    <InboxLayout
      inquiries={standardInquiries}
      inquiryTypes={types}
      categoryOptions={uniqueCategories}
      statusOptions={uniqueStatuses}
    />
  );
}
